import { TDropItem } from 'src/types';

export const confirmationOptions: TDropItem[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
];

export const agreeConfirmationOptions: TDropItem[] = [
  { value: 'agree', label: 'Agree' },
  { value: 'doNotAgree', label: 'Do not agree' },
];
